import { LucideIcon, Radar } from "lucide-react"
import { ReactNode } from "react"
import { cn } from "../utils"
import { Card } from "./Card"

type Props = {
  title: string
  description: string
  frame?: boolean
  className?: string
  icon?: LucideIcon
  cta?: ReactNode
}

export const NoData = ({ title, description, frame = false, className }: Props) => {
  return (
    <Card
      className={cn(
        "flex flex-col gap-2 bg-transparent items-center justify-center py-6 border-none shadow-none",
        !frame && "absolute inset-0 z-30",
        frame && "border border-border border-dashed",
        className,
      )}
    >
      <Radar className="size-8 text-muted-foreground" strokeWidth={1.5} />
      <div className="flex flex-col gap-0.5 items-center">
        <div className="text-muted-foreground text-base">{title}</div>
        <div className="text-muted-foreground text-xs">{description}</div>
      </div>
    </Card>
  )
}
